module.exports = __webpack_public_path__ + "svg/anim/Worm-long.svg";